module.exports = __webpack_public_path__ + "static/media/71.ce4075a5.png";